// AARJA Urgency Section Logic
(function () {
  'use strict';

  // ── CONFIG (override via data attributes on wrapper) ──────────────────
  const defaults = {
    stockThreshold: 10,       // show warning below this
    viewersMin: 8,
    viewersMax: 24,
    countdownResetHour: 20,   // 8pm local time daily reset
    countdownMinutes: 0,
  };

  // ── STOCK WARNING ─────────────────────────────────────────────────────
  function initStockWarning() {
    const el = document.querySelector('.aarja-stock-warning');
    if (!el) return;
    const qty = parseInt(el.dataset.stockQty, 10);
    const threshold = parseInt(el.dataset.threshold, 10) || defaults.stockThreshold;
    if (isNaN(qty) || qty <= 0 || qty > threshold) {
      el.style.display = 'none';
    } else {
      el.querySelector('.stock-number').textContent = qty;
    }
  }

  // ── VIEWERS BADGE ─────────────────────────────────────────────────────
  function initViewers() {
    const el = document.querySelector('.aarja-viewing-badge');
    if (!el) return;
    const min = parseInt(el.dataset.min, 10) || defaults.viewersMin;
    const max = parseInt(el.dataset.max, 10) || defaults.viewersMax;
    const count = Math.floor(Math.random() * (max - min + 1)) + min;
    el.querySelector('.viewer-count').textContent = count;

    // Fluctuate ±1 every 8-20s for realism
    setInterval(function () {
      const current = parseInt(el.querySelector('.viewer-count').textContent, 10);
      const delta = Math.random() > 0.5 ? 1 : -1;
      const next = Math.min(max, Math.max(min, current + delta));
      el.querySelector('.viewer-count').textContent = next;
    }, (Math.random() * 12000) + 8000);
  }

  // ── COUNTDOWN TIMER ───────────────────────────────────────────────────
  function initCountdown() {
    const wrapper = document.querySelector('.aarja-countdown-wrapper');
    if (!wrapper) return;

    const resetHour = parseInt(wrapper.dataset.resetHour, 10);
    const resetMin  = parseInt(wrapper.dataset.resetMin, 10) || 0;

    function getTarget() {
      const now = new Date();
      const target = new Date();
      target.setHours(resetHour, resetMin, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      return target;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      const now = new Date();
      const diff = Math.max(0, getTarget() - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      wrapper.querySelector('.h').textContent = pad(h);
      wrapper.querySelector('.m').textContent = pad(m);
      wrapper.querySelector('.s').textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  // ── INIT ──────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initStockWarning();
    initViewers();
    initCountdown();
  });
})();